import articlePage from "@faire/web-api/routes/support/articles/articleId";
export var CheckAccountVerificationStatusIA = function CheckAccountVerificationStatusIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    learnMoreLink: articles !== null && articles !== void 0 && articles.MyOrders.BUSINESS_PROFILE ? articlePage(articles.MyOrders.BUSINESS_PROFILE.id) : undefined
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return VERIFY_YOUR_ACCOUNT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [IF_YOU_PROVIDED_ALL_REQUIRED_INFO(strictLocalize)];
    }
  };
};
var VERIFY_YOUR_ACCOUNT = function VERIFY_YOUR_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "01NZtH",
    defaultMessage: [{
      "type": 0,
      "value": "Precisaremos de um mínimo de 1 dia útil para analisar as informações"
    }]
  });
};
var IF_YOU_PROVIDED_ALL_REQUIRED_INFO = function IF_YOU_PROVIDED_ALL_REQUIRED_INFO(strictLocalize) {
  return strictLocalize({
    id: "H4pphv",
    defaultMessage: [{
      "type": 0,
      "value": "Se forneceu todas as informações necessárias no formulário de verificação de conta, receberá um e-mail assim que o analisarmos. Habitualmente, respondemos no prazo de 1 dia útil."
    }]
  });
};